import { Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

const skipProp =
  (...props: string[]) =>
  (prop: PropertyKey) =>
    !props.includes(prop as string);

export const PlaybackSection = styled(Box)({
  marginTop: 24,
  marginBottom: 8,
});

export const PolicyDropdown = styled(Box, {
  shouldForwardProp: skipProp('$open'),
})<{ $open: boolean }>(({ $open }) => ({
  border: $open
    ? '1.5px solid var(--am-accent-text)'
    : '1.5px solid var(--am-border)',
  borderRadius: 8,
  overflow: 'hidden',
  background: 'var(--am-header-bg)',
  marginBottom: 8,
  transition: 'border-color 0.12s',
}));

export const PolicyDropdownHeader = styled(Box, {
  shouldForwardProp: skipProp('$open'),
})<{ $open: boolean }>(({ $open }) => ({
  padding: '10px 14px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  transition: 'background 0.12s',
  background: $open ? 'var(--am-surface-2)' : 'var(--am-surface)',
  borderBottom: $open ? '1px solid var(--am-border)' : 'none',
}));

export const PolicyDropdownItem = styled(Box, {
  shouldForwardProp: skipProp('$isSelected', '$isLast'),
})<{ $isSelected: boolean; $isLast: boolean }>(({ $isSelected, $isLast }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '10px 14px',
  cursor: 'pointer',
  transition: 'background 0.12s',
  backgroundColor: $isSelected ? 'var(--am-surface-2)' : 'transparent',
  borderBottom: $isLast ? 'none' : '1px solid var(--am-border)',
}));

export const PolicyBadge = styled(Box)({
  marginLeft: 6,
  fontSize: '10px',
  borderRadius: 4,
  padding: '1px 6px',
  fontWeight: 700,
  display: 'inline-block',
  lineHeight: 1.6,
  color: 'var(--am-text-secondary)',
  backgroundColor: 'var(--am-surface-2)',
  border: '1px solid var(--am-border)',
});

export const PolicyHeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 14,
});

export const PolicyNameRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const PolicyIcon = styled('span')({
  fontSize: 16,
});

export const PolicyName = styled(Typography)({
  fontSize: 13,
  fontWeight: 700,
  color: 'var(--am-text-primary)',
});

export const PolicyHeaderDesc = styled(Typography)({
  fontSize: 12,
  color: 'var(--am-text-secondary)',
  marginTop: 2,
});

export const PolicyItemDesc = styled(Typography)({
  fontSize: 12,
  color: 'var(--am-text-secondary)',
  marginTop: 2,
});

export const PolicyItemContent = styled(Box)({
  flex: 1,
});

export const PolicyRadioOuter = styled(Box, {
  shouldForwardProp: skipProp('$isSelected'),
})<{ $isSelected: boolean }>(({ $isSelected }) => ({
  width: 18,
  height: 18,
  borderRadius: '50%',
  border: '2px solid',
  borderColor: $isSelected ? 'var(--am-accent-text)' : 'var(--am-border-mid)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const PolicyRadioInner = styled(Box)({
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: 'var(--am-accent-text)',
});

export const PolicyExpandIcon = styled(ExpandMoreIcon, {
  shouldForwardProp: skipProp('$open'),
})<{ $open: boolean }>(({ $open }) => ({
  color: 'var(--am-text-disabled)',
  fontSize: 18,
  transform: $open ? 'rotate(180deg)' : 'none',
  transition: 'transform 0.15s',
}));
